module.exports = __webpack_public_path__ + "static/media/WeddingDetails1_tablet.272ff975.jpg";